export class Account {
  idx: string;
  bank_name?: string = "";
  bank_code?: string;
  account_number?: string;
  file_1?: string | ArrayBuffer;
  file_2?: string | ArrayBuffer;
  account_holder?: string;
  use_num?: string;
  customer_idx?: string;
  id_type?: string;
  id_number?: string;
  status?: number;
  confirm_status?: number;
  reg_date: string;
  parse = (kftc_account: KTFCAccount) => {
    this.account_holder = kftc_account.account_holder_name;
    this.account_number = kftc_account.account_num;
    this.bank_name = kftc_account.bank_code_std;
    this.use_num = kftc_account.fintech_use_num;
  };
}

export const AccountStatus = {
  /** 0 */
  Unavailable: 0,
  /** 1 */
  Available: 1,
  /** 2 */
  ConfirmedByOtherCoi: 2,
  /** 3 */
  ForcedConfirmed: 3,
  /** 4 */
  DeletedFromBank: 4,
};

export class ValidAccount {
  customer_idx: string;
  id_type: string;
  personal_id: string;
  bank_code?: string;
  account_no?: string;
  birth?: string;
  gender?: string;
  account_holder?: string;
}

export class Contact {
  cc: string;
  company?: string;
  number: string;
}

export class FileInfo {
  idx: number;
  name: string;
  type: string;
  data: string;
  updateYn: boolean = false;
}

export class Docs {
  // count?: number;
  doc_1?: string;
  doc_2?: string;
  doc_3?: string;
  doc_4?: string;
  doc_5?: string;
  doc_6?: string;
  doc_7?: string;
  doc_8?: string;
  doc_9?: string;
  doc_10?: string;
  docList?: Array<FileInfo>;
}

export class COI {
  constructor() {
    this.issue_country = "";
  }
  id_num1: string;
  id_num2: string;
  id_exp1: string;
  id_exp2: string;
  file1: string;
  file2: string;
  file3: string;
  file4: string;
  type?: string;
  issue_date?: string;
  valid_date?: string;
  nationality?: string;
  personal_no?: string;
  serial_no?: string;
  file_1?: string | ArrayBuffer;
  file_2?: string | ArrayBuffer;
  lic_no?: string;
  zip_code?: string;
  street?: string;
  street2?: string;
  issuer?: string;
  pass_no?: string;
  issue_country: string;
  pass_type?: string;
  expire_date: string;
  reg_no: string;
  // imgList?: Array<FileInfo>;
  update_yn1?: boolean;
  update_yn2?: boolean;
  coi_type?: string;
}

export class KTFCAccount {
  fintech_use_num: string;
  account_holder_name: string;
  bank_code_std: string;
  account_num: string;
  account_num_masked: string;
  transfer_agree_yn: string;
  inquiry_agree_yn: string;
}

export class KTFCUserInfo {
  user_ci: string;
  user_name: string;
  res_list: Array<KTFCAccount>;
  res_count: string;
  user_seq_no: string;
}

export class KTFCCallback {
  bank_code: string;
  account_number: string;
  account_holder: string;
  use_num: string;
  key: string;
}

export class Token {
  access_token?: string;
  refresh_token?: string;
  expires_in?: string;
  token_type?: string;
  scope?: string;
  user_seq_no?: string;
  user_ci?: string;
}

export class User {
  constructor() {
    this.nationality = "";
  }

  idx?: string;
  id?: string;
  password?: string;
  accesscode?: string;
  firstname?: string;
  middlename?: string;
  lastname?: string;
  fullname() {
    return (
      this.firstname +
      (this.middlename ? " " + this.middlename : "") +
      " " +
      this.lastname
    );
  }
  remark?: string;
  phone1: string;
  phone2: string;
  birth?: string;
  gender?: string;
  nationality?: string;
  zip_code: string;
  street: string;
  street2: string;
  coi_type: string;
  score?: number;
  coi?: COI = new COI();
  reg_date?: number;
  receiver?: Array<User>;
  status?: string;
  docs?: Docs = new Docs();
  callback_key?: string;
  doc_update_yn?: boolean;
}

export class Agent extends User {
  branch_code?: string;
  branch_name?: string;
  partner_id?: string;
  email?: string;
  phone?: string;
  name?: string;
  partner_name?: string;
  type?: string;
}

export class Customer extends User {
  constructor() {
    super();
    this.occupation = "";
    this.coi_type = "";
  }

  branch_code?: string;
  branch_name?: string;
  customer_id?: string;
  agent_name?: string;
  ci?: string;
  user_token?: Token = new Token();
  signature?: string;
  privacy_date?: string;
  tos_date?: string;
  peps_confirm?: boolean;
  kyc_status?: string;
  occupation?: string;
  kyc_verify_code?: string;
  local_firstname?: string;
  local_middlename?: string;
  local_lastname?: string;
  country?: string;
  blocked?: boolean;
  account?: Array<Account> = new Array<Account>();
  selected_account_idx?: string;
  failed_count?: number;
  recommender?: string;
  coi_check?: string;
  remarks?: string;
  email?: string;
  email_yn?: string;
  need_to_check_kyc?: boolean;
  change_pw_passcode?: string;
  forceUpdate?: boolean;

  bank_code?: string;
  account_number?: string;

  has_txn_history?: boolean = false;

  partner_customer_id?: string;

  id2?: string;
  id_c?: string;

  edit_coi_img?: boolean;
  reg_type?: string;
  residency_type?: string;

  ob_reg_date?: string;
  ob_new_user_yn?: string;

  email_verified?: number;
  email_verify_requested?: number;
  email_verify_expired?: number;
  verified_identifier?: string;

  pass_type?: string;
  pass_no?: string;
  passport_issue_date?: string;
  passport_expiry_date?: string;
}

export class EmailVerifyInfo {
  verified_identifier?: string;
  email_verified?: number;
  email_verify_requested?: number;
  email_verify_expired?: number;

  static fromCustomer(customer: Customer) {
    const info = new EmailVerifyInfo();
    info.verified_identifier = customer.verified_identifier;
    info.email_verified = customer.email_verified;
    info.email_verify_requested = customer.email_verify_requested;
    info.email_verify_expired = customer.email_verify_expired;
    return info;
  }

  static fromAnyToCustomer(obj: any, customer: Customer) {
    customer.verified_identifier = obj.verified_identifier;
    customer.email_verified = obj.email_verified;
    customer.email_verify_requested = obj.email_verify_requested;
    customer.email_verify_expired = obj.email_verify_expired;
  }

  static initInCustomer(customer: Customer) {
    customer.verified_identifier = "";
    customer.email_verified = 0;
    customer.email_verify_requested = 0;
    customer.email_verify_expired = 0;
  }
}

export class Receiver extends User {
  constructor() {
    super();
  }
  phone: string;
  customer_idx: string;
  address: string;
  id_type: string;
  id_number: string;

  fullname() {
    return super.fullname();
  }
}

export class Sender extends User {
  phone: string;
  nationality: string;
  country: string;
  gender: string;
  customer_idx: string;
  address: string;
  id_type: string;
  id_number: string;
}

export const KYCStatus = {
  started: "Started",
  "1won_sent": "1won Sent",
  checking: "Checking",
  failed: "Failed",
  completed: "Completed",
  not_completed: "Not Completed",
  expired: "Expired",
  blocked: "Blocked",
  ready: "Ready",
  invalid_idcard: "Invalid ID Card",
  aml_block: "AML Block",
  revoke: "Revoke",
  checking_account_delete: "Checking (Account Delete)",
  deactivated: "Deactivated",
  receive_only: "Inbound Only",
  registered: "Registered",
  passport_info_required: "passport_info_required",
};

export class KYCStatusList {
  list = KYCStatus;
  getList() {
    const keys = Object.keys(this.list);
    return keys;
  }
}

export class AgentType {
  agent_idx: number;
  customer_id: string;
}

export class SimilarCustomer extends Customer {
  constructor() {
    super();
  }

  account_number?: string;
  bank_code?: string;
}

export class CustomerCountByKyc {
  kyc_count: number;
  kyc_status: string;
}

export class AuthInfo {
  customer_id: string;
  email: string;
  forceApprove: boolean;
  verifyCancel: boolean;
}

export class EditBeneficiaryParam {
  transaction_id: string;
  rc_firstname: string;
  rc_middlename: string;
  rc_lastname: string;
  payout_bank_name: string;
  payout_bank_account: string;
}

export class CustomerAcocuntList {
  customer_id: number;
}

export class RefreshKftcAgreementDate {
  customer_id: number;
}

export class ThreeDigitCodeEmail {
  customerIdx: string;
  adminEmailRecipients: string;
}

export class ReportPaging {}

export class ORISReportSearch {
  searchOption: string;
  keyword: string;
  status: string;
  dateFrom: string;
  dateTo: string;
  offset: number;
  pageSize: number;
}

export class SubmitORISReport {
  dateFrom: string;
  dateTo: string;
}



// WEBPACK FOOTER //
// ./src/app/model/shared/user/user.ts